export default __webpack_public_path__ + "images/50f6c7b3c10cc3ab77ce46160ead8d29.png";